import { History } from '../../helpers/History';
import PropTypes from 'prop-types';
import React from 'react';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchNodeInfo } from '../state/actions/AdminActions';

export class DeleteResourceButton extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        fetchNodeInfo: PropTypes.func.isRequired,
        deleteAction: PropTypes.func.isRequired,
        resourceId: PropTypes.string.isRequired,
        resourceDependantCount: PropTypes.number,
        resourceActiveAnalysisCount: PropTypes.number,
        navBack: PropTypes.string,
    };

    componentDidMount = () => {
        const { fetchNodeInfo } = this.props;
        const { resourceId } = this.props;

        fetchNodeInfo(resourceId);
    };

    onDelete = async () => {
        const { deleteAction } = this.props;
        const { resourceId, navBack } = this.props;

        // TODO: when text doesn't match, leave modal open. @JPC
        const result = await Swal({
            title: 'Delete Resource',
            type: 'warning',
            input: 'text',
            showCancelButton: true,
            focusConfirm: false,
            footer: 'To delete this resource please type "delete" into the textbox, and click "OK".',
        });

        if (result.value === 'delete') {
            await deleteAction(resourceId).catch(error => {
                Swal({
                    title: 'Oops...',
                    text: error.message,
                    type: 'error',
                });
                throw error;
            });
            History.push(navBack ? navBack : '/');
        }
    };

    render() {
        const { resourceDependantCount, children } = this.props;
        const isDisabled = resourceDependantCount > 0;
        if (!isDisabled) {
            return (
                <button
                    type="button"
                    className="delete-resource btn btn-secondary"
                    disabled={isDisabled}
                    onClick={this.onDelete}
                >
                    {children}
                </button>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return state.admin;
};

const mapDispatchToProps = dispatch => bindActionCreators({ fetchNodeInfo }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeleteResourceButton);
